import type { IconData } from '@stacksjs/iconify-core'

export const otherUiLightBulb: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 11.73a6.248 6.248 0 1 0-6.001 0v.766h6.002zM8 2a4 4 0 0 1 4 4h-1.5A2.5 2.5 0 0 0 8 3.5z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M5 14a3.251 3.251 0 0 0 6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiLightBulb
